import React from 'react';
import Header from './components/Header';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import Home from './pages/Home';

import SignIn from './pages/my_account/SignIn';
import Register from './pages/my_account/Register';

import Services from './pages/aboutus/Services';
import Practices from './pages/aboutus/Practices';
import Clients from './pages/aboutus/Clients';
import ExecPartners from './pages/aboutus/ExecPartners';
import Consultants from './pages/aboutus/Consultants';
import IQosystem from './pages/aboutus/IQosystem';
import IQSTokens from './pages/aboutus/IQSTokens';

import Sector from './pages/ourleaders/Sector';
import Function from './pages/ourleaders/Function';
import Practice from './pages/ourleaders/Practice';

import Projects from './pages/Projects';
import Publications from './pages/Publications';
import Contact from './pages/Contact';
import Search from './pages/Search';

function App() {

  return (
    <Router>
      <Toaster
        position="bottom-center" 
          toastOptions={{
            style: {
              background: '#333',
              color: '#fff',
              fontSize: '16px',
              padding: '12px',
              borderRadius: '8px',
            },
            
            error: { style: { background: '#ff4d4d',},},
            success: {style: {background: '#4caf50',},},
          }}
        />
      <div>
        
        <Header/>

        <Routes>
          <Route path="/myaccount/signin" element={<SignIn/>} />
          <Route path="/myaccount/register" element={<Register/>} />

          <Route path="/aboutus/services" element={<Services/>} />
          <Route path="/aboutus/practices" element={<Practices />} />
          <Route path="/aboutus/clients" element={<Clients />} />
          <Route path="/aboutus/execpartners" element={<ExecPartners />} />
          <Route path="/aboutus/consultants" element={<Consultants />} />
          <Route path="/aboutus/iqosystem" element={<IQosystem />} />
          <Route path="/aboutus/iqstokens" element={<IQSTokens />} />

          <Route path="/ourleaders/sector" element={<Sector />} />
          <Route path="/ourleaders/function" element={<Function />} />
          <Route path="/ourleaders/practice" element={<Practice />} />

          <Route path="/projects" element={<Projects />} />
          <Route path="/publications" element={<Publications/>} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/search" element={<Search />} />

          <Route path="/" element={<Home/>} />
        </Routes>
      </div>
    </Router>
    
  );
}

export default App;
